

class ShopByColourSwatch extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', () => {
			const tab = this.closest('tab-panel').getAttribute('tab');
			const swatches = this.closest('.sbc__swatches').querySelectorAll('sbc-swatch');
			swatches.forEach(s => s.removeAttribute('active'));

			this.setAttribute('active', '');
			this.replaceLink();
			this.filterCards(true);
		});

		if (this.hasAttribute('active')) {
			const observer = new IntersectionObserver(entries => {
				if (entries.some(e => e.isIntersecting)) {
					observer.disconnect();
					this.filterCards(false);
				}
			});

			observer.observe(this);
		}

		const observer = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				if (this.hasAttribute('active')) this.replaceLink();
			}
		});

		observer.observe(this);
	}

	// Hides cards for products that don't come in this colour, optionally switching the rest to it
	async filterCards(select) {
		const tab = this.closest('tab-panel').getAttribute('tab');
		const colour = this.getAttribute('colour');
		const panel = this.closest('.shopify-section').querySelector(`tab-panel.flex-section__cards[tab="${tab}"]`);
		if (panel == null) return;

		const swatchSelectors = [...panel.querySelectorAll('card-swatch-selector')];
		await Promise.all(swatchSelectors.map(swatchSelector => swatchSelector.load()));

		// Another swatch was clicked while the swatches were loading
		if (!this.hasAttribute('active')) return;

		for (const swatchSelector of swatchSelectors) {
			const cardSwatch = swatchSelector.querySelector(`card-swatch[colour="${colour}"]`);
			swatchSelector.closest('.card').toggleAttribute('hidden', cardSwatch == null);
			if (select && cardSwatch) cardSwatch.select();
		}

		const list = panel.querySelector('ul');
		list.scrollLeft = 0;
		list.dispatchEvent(new Event('scroll'));
	}

	replaceLink() {
		const link = this.getAttribute('link');
		const button = this.closest('.shopify-section').querySelector('.sbc__button');
		if (button == null) return;

		const label = button.dataset.label.replace('[colour]', this.getAttribute('colour')); 
		const url = link && link.length > 0 ? link : button.dataset.link;

		button.href = url;
		button.textContent = label;
	}
}

customElements.define('sbc-swatch', ShopByColourSwatch);